import { Injectable } from '@angular/core';
import type { MapboxMap } from '@polaris-customerweb/sharedcomponents.core';

@Injectable({ providedIn: 'root' })
export class TerrainMapService {
    addSources(mapboxMap: MapboxMap) {
        if (!mapboxMap.getSource('mapbox-dem')) {
            mapboxMap.addSource('mapbox-dem', {
                maxzoom: 14,
                tileSize: 512,
                type: 'raster-dem',
                url: 'mapbox://mapbox.mapbox-terrain-dem-v1',
            });
        }
    }

    set3dTerrain(mapboxMap: MapboxMap, visible = true) {
        if (visible) {
            mapboxMap.setTerrain({ exaggeration: 1.5, source: 'mapbox-dem' });
        } else {
            mapboxMap.setTerrain();
        }
    }
}
